import SearchFormDateValidation from './SearchFormDateValidation';

export default SearchFormDateValidation;
